export default function TikTokIcon({ size = 18, className = "" }) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
            <path d="M16.6 5.82c-.8-.85-1.24-1.96-1.24-3.14h-3.2v13.3a2.63 2.63 0 1 1-2.63-2.63c.19 0 .38.02.56.05V9.98a5.83 5.83 0 0 0-.56-.03A5.86 5.86 0 0 0 3.67 15.8a5.86 5.86 0 0 0 10.72 3.28 5.83 5.83 0 0 0 1-3.28V8.4a8.13 8.13 0 0 0 4.77 1.53V6.75a4.86 4.86 0 0 1-3.56-.93z" />
        </svg>
    );
}
